import { render, staticRenderFns } from "./InlineNotification.vue?vue&type=template&id=0c95fdd2"
import script from "./InlineNotification.vue?vue&type=script&lang=js"
export * from "./InlineNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports